module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Building/images/tankodrome-lvl2-100.1643ff84.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Building/images/tankodrome-lvl2-100.png
// module id = 3330
// module chunks = 11